import axios from 'axios'
import { RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';
import { salvarCacheFormasUsuario, carregarCacheFormasUsuario } from '../../util/offlineStorage';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default function recuperarPagamentosDesativadosUsuario (idEmpresa) {
  const url = `${URL}/usuarios-empresa/empresa/${idEmpresa}/pagamentos-desativados-usuario`;
  return dispatch => axios.get(url, OFFLINE_AWARE_CONFIG)
    .then(response => {
      salvarCacheFormasUsuario(idEmpresa, response.data);
      return dispatch({ type: RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO, payload: response });
    })
    .catch(erro => {
      if (!navigator.onLine || !erro.response) {
        const cache = carregarCacheFormasUsuario(idEmpresa);
        return dispatch({ type: RECUPERAR_PAGAMENTOS_DESATIVADOS_USUARIO, payload: { data: cache || [] } });
      }
      throw erro;
    });
}
